import { Link } from "react-router-dom";

const HelpLinks = () => {
    return (
        <div className="flex flex-col items-center justify-center gap-2 w-[5rem] text-yellow-600">
            <p className="text-xl font-bold text-yellow-900">المساعده</p>
            <Link to="/contactus">
                <p className="hover:underline">تواصل معنا</p>
            </Link>
            <p dir="ltr">+01234567890</p>
        </div>
    );
};

export default HelpLinks;
